import { cn } from '../../utils'
import { MenuProps } from './types'

/**
 *
 * @param menuTitle - The title of the menu
 * @param children - The content of the menu
 * @param className - The class name of the menu
 * @param menuTitleClassName - The class name of the menu title
 *
 */
export const Menu = ({
    menuTitle,
    className,
    menuTitleClassName,
    children,
}: MenuProps) => {
    return (
        <div
            className={cn(
                'inline-flex w-[200px] flex-col items-start justify-start gap-3 py-2',
                className
            )}
        >
            <div className="inline-flex items-center justify-start gap-5 self-stretch">
                <div
                    className={cn(
                        'font-sans text-xs font-normal leading-tight text-slate-500',
                        menuTitleClassName
                    )}
                >
                    {menuTitle}
                </div>
            </div>
            {children}
        </div>
    )
}
